import { WHATSAPP_NUMBER } from "./api";

export const buildWhatsAppOrderMessage = ({ items, subtotal, discount, total, coupon, customer, address, location, notes }) => {
  const lines = [];
  lines.push(`🌸 *New Order — Sugandhi Flowers*`);
  lines.push("");
  lines.push(`*Customer:* ${customer || "-"}`);
  if (address) lines.push(`*Address:* ${address}`);
  if (location?.lat && location?.lng) {
    lines.push(`*Location:* https://maps.google.com/?q=${location.lat},${location.lng}`);
  }
  lines.push("");
  lines.push(`*Items:*`);
  items.forEach((it, idx) => {
    lines.push(`${idx + 1}. ${it.name} × ${it.quantity} — ₹${(it.price * it.quantity).toLocaleString("en-IN")}`);
  });
  lines.push("");
  lines.push(`*Subtotal:* ₹${subtotal.toLocaleString("en-IN")}`);
  if (coupon?.code) lines.push(`*Coupon ${coupon.code}:* -₹${(discount || 0).toLocaleString("en-IN")}`);
  lines.push(`*Total:* ₹${total.toLocaleString("en-IN")}`);
  if (notes) { lines.push(""); lines.push(`*Notes:* ${notes}`); }
  lines.push("");
  lines.push("Please confirm & share payment details 💐");
  return lines.join("\n");
};

export const buildWhatsAppSingleProduct = (product) => {
  const msg = `🌸 Hi Sugandhi Flowers!\n\nI'd like to buy:\n*${product.name}* — ₹${product.price.toLocaleString("en-IN")}\n\nPlease confirm availability & payment options.`;
  return msg;
};

export const openWhatsApp = (message) => {
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};
